// IE 2026 09 25 / ODOO-… (заказ Игоря: форматирование строк из подсказки): КНОПКИ «ЦВЕТ ТЕКСТА» (A) И «ФОН» (палитра) В РЯДУ КНОПОК-ДЕЙСТВИЙ
// ALT-ПОДСКАЗКИ пунктов-записей панелей-меню (страницы и группы панели страниц, виджеты под страницей и виджеты меню страницы, узлы панели задач
// в шапке и вкладки Tasks panel) и плиток / подписей рейла страниц — как кнопки «A» / 🎨 панели действий строки грида (Screen2 заказа).
// Заказ (25.09, дословно): «Добавь в форме-меню, при нажатии Alt в командной панели tooltip, кнопки форматирования как на Screen2»; «Ожидаю, что можно
// будет изменить цвет и фон … не только для визуализации в форме-меню, но и — если это форма-меню страниц — бейджик, который визуализируется в рейле
// страниц …; и там тоже должна быть возможность при нажатом Alt в подсказке воспользоваться этими командами».
//
// Как устроено:
// - кнопки (tipFormat.actions(target) → tipActions_html) — только у пунктов-записей и только администратору (store.checkAccess access-admin, как
//   «Edit description»), выключатель fe.ux.menuRowFormatEdit (вкл.); у команд (панель пользователя, ≡ виджета / таблицы) строки записи нет — кнопок нет;
// - клик по кнопке — В САМОЙ ПОДСКАЗКЕ ряд кнопок сменяется полосой образцов (open): та же палитра, что у wj-color-picker грида (10 базовых цветов wijmo
//   и 5 оттенков каждого — как ColorPicker._updatePalette), «без цвета» и произвольный цвет #rrggbb (поле + Enter / ✓); клик по образцу → apply →
//   ряд кнопок возвращается; Esc / × — вернуть ряд кнопок. Подсказка на это время не гаснет: клики внутри полосы не идут дальше (панель-меню не
//   закрывается по «клику мимо»), при дожитии после Alt курсор над подсказкой — зона удержания altTooltip, в режиме «Show tooltips» — удержание
//   tipActions (полоса живёт в том же блоке .tip-actions);
// - применение (set): (1) В ПАМЯТИ — строка записи получает ТОТ ЖЕ канал, что пишет палитра грида (AttrGrid.set_color2):
//   _cells.<binding>.fields[0].style[color | background-color] (binding — node.valueStr), во ВСЕХ копиях строки: копия страницы WS.PAGES[id]
//   (панель страниц, рейл), строка WS.record.doc.pages / doc.data_tasks, снимок панели задач store.tasksBar, открытые формы записи-владельца —
//   пункт панели, заголовок группы и плитка / подпись рейла перекрашиваются сразу (реактивно; снимок задач — новым объектом снимка);
//   (2) НА СЕРВЕРЕ — метод бэка menu_row_format (common_modules/menu_row_format.py): запись перечитывается из базы, патчится только style этого
//   канала, сохраняется путём формы; ответ несёт итоговый style (сверяется с памятью) и версию записи (sequence_id / updated_at — в копии стора и
//   открытых форм, чтобы их следующее сохранение не упёрлось в конфликт). Ошибка / бэк без метода → уведомление «Formatting applied for this session
//   only — not saved», цвет остаётся в памяти;
// - счётчики — window.tipFormat.stats; палитра — tipFormat_palette() (для проб).
import { t } from '@/i18n'
import altTooltip from './altTooltip'
import { MENU_FORMAT_BINDING, menuFormat_fromRow } from './menuFormat'
import { uiHelp_reshow } from './uiHelp.js'

const escHtml = (s) => String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;')
const isObj = (x) => !!(x && typeof x === 'object')
const RUNTIME_ROWS = ['more', 'user-widgets']

export const TIP_FORMAT_ACTS = { fmtcolor: 'color', fmtbg: 'background-color' }
export const TIP_FORMAT_KINDS = ['page', 'group', 'widget', 'task']
// 10 базовых цветов wj-color-picker (wijmo.input ColorPicker: palette по умолчанию) — те же, что у палитры грида
export const TIP_FORMAT_BASE = ['#FFF', '#000', '#F00', '#FFC000', '#FFFF00', '#92D050', '#00B050', '#00B0F0', '#0070C0', '#7030A0']

// ---- палитра: строка базовых цветов + 5 строк оттенков, как ColorPicker._updatePalette (серые: между белым и чёрным; цветные: fromHsb(h, .1 + .2u, 1 − .1u))
const hex2 = (n) => Math.max(0, Math.min(255, Math.round(n))).toString(16).padStart(2, '0')
export function tipFormat_hex(r, g, b) { return '#' + hex2(r) + hex2(g) + hex2(b) }
export function tipFormat_parseHex(s) {
    const m3 = /^#([0-9a-f]{3})$/i.exec(String(s || '').trim()), m6 = /^#([0-9a-f]{6})$/i.exec(String(s || '').trim())
    if (m3) return m3[1].split('').map(c => parseInt(c + c, 16))
    if (m6) return [0, 2, 4].map(i => parseInt(m6[1].slice(i, i + 2), 16))
    return null
}
export function tipFormat_rgbToHsb(rgb) {
    const r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255
    const max = Math.max(r, g, b), min = Math.min(r, g, b), d = max - min
    let h = 0
    if (d) {
        if (max === r) h = ((g - b) / d) % 6
        else if (max === g) h = (b - r) / d + 2
        else h = (r - g) / d + 4
        h *= 60; if (h < 0) h += 360
    }
    return [h, max ? d / max : 0, max]
}
export function tipFormat_hsbToRgb(h, s, v) {
    const c = v * s, x = c * (1 - Math.abs(((h / 60) % 2) - 1)), m = v - c
    let r = 0, g = 0, b = 0
    if (h < 60) { r = c; g = x } else if (h < 120) { r = x; g = c } else if (h < 180) { g = c; b = x } else if (h < 240) { g = x; b = c } else if (h < 300) { r = x; b = c } else { r = c; b = x }
    return [(r + m) * 255, (g + m) * 255, (b + m) * 255]
}
let _palette = null
export function tipFormat_palette() {
    if (_palette) return _palette
    const rows = [[], [], [], [], [], []]
    for (const base of TIP_FORMAT_BASE) {
        const rgb = tipFormat_parseHex(base)
        const [h, s, b] = tipFormat_rgbToHsb(rgb)
        rows[0].push(tipFormat_hex(...rgb))
        for (let u = 0; u < 5; u++) {
            let sh
            if (s === 0) { const pct = 0.1 * u + (b > 0.5 ? 0.05 : 0.55); sh = [255, 255, 255].map(x => x * (1 - pct)) }   // Color.interpolate(white, black, pct)
            else sh = tipFormat_hsbToRgb(h, 0.1 + 0.2 * u, 1 - 0.1 * u)
            rows[u + 1].push(tipFormat_hex(...sh))
        }
    }
    _palette = rows
    return rows
}

// ---- строки записей (те же правила, что у бэка menu_row_format / workspaces._row_ref / _is_page_group)
export function tipFormat_rowRef(row) {
    if (!isObj(row)) return ''
    const v = row.page || row.widget || row.workspace || (isObj(row.node) ? row.node.value : undefined)
    return (v === undefined || v === null) ? '' : String(v)
}
export function tipFormat_isGroup(row) {
    return isObj(row) && Array.isArray(row.attrs) && !(isObj(row.node) && row.node.relation_segment) && !row.page && !row.widget && !row.workspace && !RUNTIME_ROWS.includes(row.name)
}
function* walk(rows, path = []) {
    const list = Array.isArray(rows) ? rows : []
    for (let i = 0; i < list.length; i++) {
        const row = list[i]
        if (!isObj(row) || RUNTIME_ROWS.includes(row.name)) continue
        const p = path.concat(i)
        yield [row, p]
        yield* walk(row.attrs, p)
    }
}
export function tipFormat_byPath(rows, path) {
    let cur = rows, row = null
    for (const i of path || []) {
        if (!Array.isArray(cur) || typeof i !== 'number' || i < 0 || i >= cur.length) return null
        row = cur[i]
        if (!isObj(row)) return null
        cur = row.attrs
    }
    return row
}
// строка по виду: page — строка-страница (группы пропускаются), group — группа страниц по node.value, widget — любая строка-ссылка по ref,
// task — сначала по пути (с проверкой id), затем первая по id. → { row, path } | null
export function tipFormat_findRow(rows, kind, id, path = null) {
    const rid = String(id ?? '')
    if (!rid || !Array.isArray(rows)) return null
    if (Array.isArray(path) && path.length) {
        const row = tipFormat_byPath(rows, path)
        if (row && tipFormat_rowRef(row) === rid && (kind !== 'group' || tipFormat_isGroup(row))) return { row, path: path.slice() }
    }
    for (const [row, p] of walk(rows)) {
        if (kind === 'group') { if (tipFormat_isGroup(row) && String((row.node || {}).value ?? '') === rid) return { row, path: p }; continue }
        if (kind === 'page' && tipFormat_isGroup(row)) continue
        if (tipFormat_rowRef(row) === rid) return { row, path: p }
    }
    return null
}
// путь строки по тождеству объекта (задача: одна запись бывает в дереве несколько раз)
export function tipFormat_pathOf(rows, target) {
    for (const [row, p] of walk(rows)) if (row === target) return p
    return null
}
// группа страниц стола по ключу (node.value строки-группы WS.record.doc.pages) — для оформления заголовка группы в панели страниц и в рейле
export function tipFormat_pageGroupRow(store, workspace, key) {
    const rows = store?.WORKSPACES?.[workspace]?.record?.doc?.pages
    const f = tipFormat_findRow(rows, 'group', key)
    return f ? f.row : null
}

// ---- канал оформления ячейки: _cells.<binding>.fields[0].style (как store.set_value грида: части binding — вложенные объекты)
export function tipFormat_styleSet(row, binding, patch) {
    if (!isObj(row)) return null
    const parts = String(binding || MENU_FORMAT_BINDING).split('.').filter(Boolean)
    if (!isObj(row._cells)) row._cells = {}
    let cur = row._cells
    for (const p of parts) { if (!isObj(cur[p])) cur[p] = {}; cur = cur[p] }
    if (!Array.isArray(cur.fields) || !cur.fields.length) cur.fields = [{}]
    if (!isObj(cur.fields[0])) cur.fields[0] = {}
    if (!isObj(cur.fields[0].style)) cur.fields[0].style = {}
    const st = cur.fields[0].style
    if (patch === null) { delete st.color; delete st['background-color'] }
    else for (const k in patch) { const v = patch[k]; if (v === null || v === undefined || v === '') delete st[k]; else st[k] = String(v) }
    return { ...st }
}
export function tipFormat_styleGet(row, binding) {
    return menuFormat_fromRow(row, binding || MENU_FORMAT_BINDING).style
}

const tipFormat = {
    store: null,
    _installed: false,
    box: null, saved: '', prop: '', target: null, active: false,   // active — полоса образцов открыта
    stats: { shows: 0, opens: 0, applies: 0, saved: 0, unchanged: 0, errors: 0, synced: 0, cancels: 0, reattaches: 0, dropped: 0 },
    _mo: null,   // наблюдатель контента подсказки, пока полоса открыта
    _hexFocus: false,   // поле #rrggbb в фокусе (focusin / focusout документа; сброс отложен и только у поля, оставшегося в документе — Chrome шлёт focusout и при удалении узла)
    install(store) {
        this.store = store
        if (this._installed) return
        this._installed = true
        // Esc — вернуть ряд кнопок, подсказку не гасить: window capture раньше слушателей дожития altTooltip и панели-меню (они ставятся позже)
        this._onKey = (e) => this.onKey(e)
        window.addEventListener('keydown', this._onKey, true)
        // hex text and focus survive a re-render: фокус поля #rrggbb — флагом (при перерисовке подсказки поле создаётся заново, _reattach возвращает текст и фокус);
        // focusout при УДАЛЕНИИ поля из DOM (Chrome) флаг не снимает — сброс отложен и делается только у поля, оставшегося в документе
        this._onFocus = (e) => {
            const el = e.target
            if (!(el && el.classList && el.classList.contains('tip-fmt-hex'))) return
            if (e.type === 'focusin') { this._hexFocus = true; return }
            setTimeout(() => { if (el.isConnected && document.activeElement !== el) this._hexFocus = false }, 0)
        }
        document.addEventListener('focusin', this._onFocus, true)
        document.addEventListener('focusout', this._onFocus, true)
        window.tipFormat = this
    },
    uninstall() {
        if (!this._installed) return
        this._installed = false
        window.removeEventListener('keydown', this._onKey, true)
        if (this._onFocus) { document.removeEventListener('focusin', this._onFocus, true); document.removeEventListener('focusout', this._onFocus, true) }
        this.close(false)
    },
    setting(key, def) { try { const s = this.store; return s && typeof s.setting === 'function' ? s.setting(key, def) : def } catch (e) { return def } },
    isAdmin() { try { return !!(this.store && this.store.checkAccess && this.store.checkAccess({ viewAccess: 'access-admin' })) } catch (e) { return false } },
    // кнопки видны: кнопки-действия включены (fe.ux.tooltipActions), выключатель fe.ux.menuRowFormatEdit, администратор
    canEdit() { return this.setting('fe.ux.tooltipActions', true) !== false && this.setting('fe.ux.menuRowFormatEdit', true) !== false && this.isAdmin() },
    isAct(act) { return Object.prototype.hasOwnProperty.call(TIP_FORMAT_ACTS, act) },

    // ---- цель: { kind, record, segment, id, path?, workspace, page? } → кнопки
    actions(target) {
        if (!target || !TIP_FORMAT_KINDS.includes(target.kind) || !target.record || !target.id || !this.canEdit()) return []
        const arg = { kind: 'tipformat', target: { kind: target.kind, record: String(target.record), segment: String(target.segment || ''), id: String(target.id), workspace: String(target.workspace || ''), page: String(target.page || ''), path: Array.isArray(target.path) ? target.path : undefined, binding: target.binding || undefined } }
        return [
            { act: 'fmtcolor', title: t('Text colour'), glyph: '<span class="tip-fmt-a">A</span>', arg },
            { act: 'fmtbg', title: t('Background colour'), icon: 'pi-palette', arg },
        ]
    },
    pageTarget(workspace, pageId) {
        const WS = this.store?.WORKSPACES?.[workspace]
        if (!WS || !pageId) return null
        return { kind: 'page', record: String(workspace), segment: String(WS.record?.segment || 'WORKSPACE'), id: String(pageId), workspace: String(workspace) }
    },
    groupTarget(workspace, key) {
        const WS = this.store?.WORKSPACES?.[workspace]
        if (!WS || !key || !tipFormat_pageGroupRow(this.store, workspace, key)) return null
        return { kind: 'group', record: String(workspace), segment: String(WS.record?.segment || 'WORKSPACE'), id: String(key), workspace: String(workspace) }
    },
    // пункт панели-меню (сырая строка MenuPanel) → цель: страница / виджет под страницей / группа панели страниц (_group + _row) / задача (_owner + _row + _path) /
    // строка меню страницы (PAGE.attrs как есть: виджеты и группы записи страницы; синтетические группы, runtime-строки и команды — нет)
    menuTarget(r, opts = {}) {
        if (!isObj(r) || !this.canEdit()) return null
        const store = this.store, WS = store?.activeWORKSPACE
        const ws = String(opts.workspace || WS?.workspace || '')
        if (!ws) return null
        const seg = String(WS?.record?.segment || 'WORKSPACE')
        if (r._page && r._widget) return { kind: 'widget', record: String(r._page), segment: 'PAGE', id: String(r._widget), workspace: ws, page: String(r._page) }
        if (r._page) return { kind: 'page', record: ws, segment: seg, id: String(r._page), workspace: ws }
        if (r._group) return isObj(r._row) ? { kind: 'group', record: ws, segment: seg, id: String(r._group), workspace: ws } : null
        if (isObj(r._owner) && r._owner.record && isObj(r._row) && isObj(r._row.node)) {
            const id = tipFormat_rowRef(r._row)
            return id ? { kind: 'task', record: String(r._owner.record), segment: String(r._owner.segment || ''), id, path: Array.isArray(r._path) ? r._path : undefined, workspace: ws } : null
        }
        if (opts.help === 'page') {
            if (r._synthetic || RUNTIME_ROWS.includes(r.name) || r._rightAction || r._fn || r.command === 'page_open' || r.new) return null
            const id = tipFormat_rowRef(r)
            const page = String(WS?.active_page || '')
            if (!id || !page) return null
            return { kind: 'widget', record: page, segment: 'PAGE', id, workspace: ws, page }
        }
        return null
    },
    menuActions(r, opts = {}) { const tg = this.menuTarget(r, opts); return tg ? this.actions(tg) : [] },

    // ---- все копии строки в памяти (пункт панели, рейл, запись стора, снимок задач, открытые формы)
    recordWidgets(recordId) {
        const out = [], rid = String(recordId || '')
        if (!rid) return out
        for (const WS of Object.values(this.store?.WORKSPACES || {})) for (const W of (WS?.ALL_WIDGETS || [])) if (W && !W.close && isObj(W.record) && String(W.record.id) === rid) out.push(W)
        return out
    },
    rowsFor(target) {
        const store = this.store, out = []
        const push = (r) => { if (isObj(r) && !out.includes(r)) out.push(r) }
        const found = (rows, kind, id, path) => { const f = tipFormat_findRow(rows, kind, id, path); return f ? f.row : null }
        const { kind, id } = target
        if (kind === 'page' || kind === 'group') {
            const ws = String(target.record), WS = store?.WORKSPACES?.[ws]
            if (kind === 'page') push(WS?.PAGES?.[id])
            push(found(WS?.record?.doc?.pages, kind, id))
            for (const W of this.recordWidgets(ws)) push(found(W.record?.doc?.pages, kind, id))
        } else if (kind === 'widget') {
            const WS = store?.WORKSPACES?.[String(target.workspace)], P = WS?.PAGES?.[String(target.page)]
            push(found(P?.attrs, 'widget', id))
            push(found(found(WS?.record?.doc?.pages, 'page', String(target.page))?.attrs, 'widget', id))
            for (const W of this.recordWidgets(target.record)) push(found(W.record?.doc?.pages, 'widget', id))
        } else if (kind === 'task') {
            const ws = String(target.record), WS = store?.WORKSPACES?.[ws]
            push(found(store?.tasksBar?.[ws]?.rows, 'task', id, target.path))
            push(found(WS?.record?.doc?.data_tasks, 'task', id, target.path))
            for (const W of this.recordWidgets(ws)) push(found(W.record?.doc?.data_tasks, 'task', id, target.path))
        }
        return out
    },
    currentValue(target, prop) {
        const row = this.rowsFor(target)[0]
        return row ? String(tipFormat_styleGet(row, target.binding)[prop] || '') : ''
    },
    // снимок панели задач — markRaw: пересборка пунктов по новому объекту снимка
    bump(target) {
        if (target.kind !== 'task') return
        const store = this.store, ws = String(target.record), st = store?.tasksBar?.[ws]
        if (st) store.tasksBar[ws] = { ...st }
    },

    // ---- полоса образцов внутри подсказки
    stripHtml(prop, current) {
        const cur = String(current || '').toLowerCase()
        const cells = tipFormat_palette().map(row => row.map(c => `<button type="button" tabindex="-1" class="tip-swatch${c.toLowerCase() === cur ? ' is-current' : ''}" data-tip-color="${c}" style="background:${c}" title="${c}"></button>`).join('')).join('')
        return `<div class="tip-fmt-head"><span class="tip-fmt-title">${escHtml(prop === 'color' ? t('Text colour') : t('Background colour'))}</span>`
            + `<button type="button" tabindex="-1" class="tip-btn tip-swatch-none${cur ? '' : ' is-current'}" data-tip-color="" title="${escHtml(t('No colour'))}"><i class="pi pi-ban"></i></button>`
            + `<button type="button" tabindex="-1" class="tip-btn tip-fmt-back" data-tip-fmt="back" title="${escHtml(t('Back (Esc)'))}"><i class="pi pi-times"></i></button></div>`
            + `<div class="tip-fmt-grid">${cells}</div>`
            + `<div class="tip-fmt-custom"><input type="text" class="tip-fmt-hex" maxlength="7" placeholder="#rrggbb" title="${escHtml(t('Custom colour: #rrggbb'))}" value="${escHtml(cur.startsWith('#') ? cur : '')}" spellcheck="false" autocomplete="off">`
            + `<button type="button" tabindex="-1" class="tip-btn tip-fmt-apply" data-tip-fmt="apply" title="${escHtml(t('Apply'))}"><i class="pi pi-check"></i></button></div>`
    },
    // клик по кнопке «A» / «палитра» (tipActions.onClick): ряд кнопок → полоса образцов, подсказка остаётся
    open(btn, act, arg) {
        const target = arg && arg.target
        const box = btn && btn.closest ? btn.closest('.tip-actions') : null
        if (!box || !target || !this.isAct(act)) return false
        this.close(false)
        this.box = box; this.saved = box.innerHTML; this.prop = TIP_FORMAT_ACTS[act]; this.target = target; this.active = true
        box.classList.add('tip-fmt')
        box.innerHTML = this.stripHtml(this.prop, this.currentValue(target, this.prop))
        this.stats.opens++
        // подсказка держится, пока полоса открыта: дожитие после Alt не завершается по уходу курсора / прокрутке / страховочному таймеру (altTooltip.holdLinger),
        // в режиме «Show tooltips» wijmo не прячет (tipActions._checkBoundsAndHide), а перерисованный контент (uiHelp_reshow по ответу объяснений записи) получает полосу заново
        altTooltip.holdLinger = true
        this._watch(box)
        try { const inp = box.querySelector('.tip-fmt-hex'); if (inp && !altTooltip.held) inp.focus({ preventScroll: true }) } catch (e) { /* нет фокуса */ }
        return true
    },
    close(restore = true) {
        const box = this.box
        if (box && restore && box.isConnected && this.active) { box.classList.remove('tip-fmt'); box.innerHTML = this.saved; this.stats.cancels++ }
        this.box = null; this.saved = ''; this.prop = ''; this.target = null; this.active = false; this._hexFocus = false
        altTooltip.holdLinger = false
        this._unwatch()
    },
    _watch(box) {
        this._unwatch()
        const tip = box.closest ? box.closest('.wj-tooltip') : null
        if (!tip || typeof MutationObserver === 'undefined') return
        this._mo = new MutationObserver(() => this._reattach(tip))
        this._mo.observe(tip, { childList: true })
    },
    _unwatch() { if (this._mo) { try { this._mo.disconnect() } catch (e) { /* уже отключён */ } this._mo = null } },
    // контент подсказки перерисован под открытой полосой (uiHelp_reshow: пришли объяснения записи) — полоса ставится заново в новый блок кнопок
    _reattach(tip) {
        if (!this.active || !this.box || this.box.isConnected) return
        const box = tip.querySelector('.tip-actions')
        if (!box || box.classList.contains('tip-fmt')) return
        // элемент подсказки wijmo общий: новый контент может быть подсказкой ДРУГОГО элемента — полоса прежней цели туда не переезжает (иначе у него
        // пропадали кнопки, а образец применялся к прежней цели); цель узнаётся по кнопке fmtcolor нового блока (data-tip-arg.target)
        if (this.boxTargetSig(box) !== JSON.stringify(this.target || null)) { this.stats.dropped++; this.close(false); return }
        // набранный текст, выделение, пометка «плохой цвет» и фокус старого поля #rrggbb переезжают в новое (замер dev02: ответ объяснений записи
        // приходил во время набора — поле пустело, Enter уходил в пустоту)
        const oldInp = this.box && this.box.querySelector ? this.box.querySelector('.tip-fmt-hex') : null
        const keep = oldInp ? { v: oldInp.value, s: oldInp.selectionStart, e: oldInp.selectionEnd, bad: oldInp.classList.contains('is-bad'), focus: this._hexFocus } : null
        this.box = box; this.saved = box.innerHTML
        box.classList.add('tip-fmt')
        box.innerHTML = this.stripHtml(this.prop, this.currentValue(this.target, this.prop))
        this.stats.reattaches++
        const inp = keep ? box.querySelector('.tip-fmt-hex') : null
        if (inp) {
            if (keep.v) inp.value = keep.v
            if (keep.bad) inp.classList.add('is-bad')
            if (keep.focus) { try { inp.focus({ preventScroll: true }); if (Number.isInteger(keep.s)) inp.setSelectionRange(keep.s, keep.e) } catch (e) { /* без фокуса */ } }
        }
    },
    // цель блока кнопок подсказки — по кнопке fmtcolor (data-tip-arg = { kind: 'tipformat', target }); блока без кнопок форматирования — 'null'
    boxTargetSig(box) {
        try {
            const b = box && box.querySelector ? box.querySelector('.tip-btn[data-tip-act="fmtcolor"]') : null
            const arg = b ? JSON.parse(b.getAttribute('data-tip-arg') || 'null') : null
            return JSON.stringify((arg && arg.target) || null)
        } catch (e) { return 'null' }
    },
    // делегированный клик документа (tipActions.onClick, capture): внутри полосы — образец / «без цвета» / назад / применить; иначе — мимо
    onDocClick(e) {
        const box = e.target && e.target.closest ? e.target.closest('.tip-actions.tip-fmt') : null
        if (!box || !box.closest('.wj-tooltip')) return false
        e.preventDefault(); e.stopImmediatePropagation()
        const sw = e.target.closest('[data-tip-color]')
        if (sw) { this.apply(sw.getAttribute('data-tip-color') || ''); return true }
        const b = e.target.closest('[data-tip-fmt]'), k = b ? b.getAttribute('data-tip-fmt') : ''
        if (k === 'back') { this.close(true); return true }
        if (k === 'apply') { this.applyHex(); return true }
        return true
    },
    onKey(e) {
        if (!this.active) return
        const inHex = !!(e.target && e.target.classList && e.target.classList.contains('tip-fmt-hex'))
        if (e.key === 'Escape') { e.preventDefault(); e.stopImmediatePropagation(); this.close(true); return }
        if (inHex) { if (e.key === 'Enter') { e.preventDefault(); e.stopImmediatePropagation(); this.applyHex() } else if (!['Alt', 'Control', 'Shift', 'Meta'].includes(e.key)) e.stopPropagation() }   // буквы — полю, не хоткеям; модификаторы — дальше (Alt-подсказки)
    },
    applyHex() {
        const inp = this.box && this.box.querySelector ? this.box.querySelector('.tip-fmt-hex') : null
        const v = String(inp ? inp.value : '').trim()
        if (!v) { this.apply(''); return }
        if (!tipFormat_parseHex(v)) { if (inp) { inp.classList.add('is-bad'); try { inp.focus() } catch (e) { /* без фокуса */ } } return }
        this.apply(v)
    },
    apply(value) {
        const prop = this.prop, target = this.target
        this.close(true)
        if (!target || !prop) return
        this.stats.applies++
        this.set(target, prop, value)
        // подсказка — заново тем же контентом (строка «Formatting», свежий ряд кнопок); не вышло — ряд уже возвращён close(true)
        try { uiHelp_reshow() } catch (e) { /* подсказки уже нет */ }
    },
    // применить: в памяти (все копии строки) → на сервере (запись-владелец)
    set(target, prop, value) {
        const v = String(value || '').trim()
        let val = v ? (tipFormat_parseHex(v) ? tipFormat_hex(...tipFormat_parseHex(v)) : v) : null   // #rgb → #rrggbb, как toString() wijmo
        if (val === '#ffffff') val = null   // белый = сброс, как у палитры грида (set_color2: value !== '#ffffff' ? value : '')
        const patch = { [prop]: val }
        let style = null
        for (const row of this.rowsFor(target)) style = tipFormat_styleSet(row, target.binding, patch)
        this.bump(target)
        return this.save(target, patch, style)
    },
    save(target, patch, localStyle) {
        const store = this.store
        const params = { record_id: String(target.record), segment: String(target.segment || ''), row: { kind: target.kind, id: String(target.id), path: Array.isArray(target.path) ? target.path : undefined }, binding: target.binding || MENU_FORMAT_BINDING, style: patch }
        return new Promise((resolve) => {
            let done = false
            const fin = (ok, reason, answer) => {
                if (done) return
                done = true; clearTimeout(tm)
                if (ok) {
                    if (answer.unchanged) this.stats.unchanged++; else this.stats.saved++
                    this.versions(target, answer.record)
                    // сверка с итогом бэка: расхождение (другие ключи в style записи) — память приводится к базе
                    const srv = isObj(answer.row) && isObj(answer.row.style) ? answer.row.style : null
                    if (srv && localStyle && JSON.stringify(srv) !== JSON.stringify(localStyle)) {
                        for (const row of this.rowsFor(target)) { tipFormat_styleSet(row, target.binding, null); tipFormat_styleSet(row, target.binding, { color: srv.color || null, 'background-color': srv['background-color'] || null }) }
                        this.bump(target); this.stats.synced++
                    }
                } else {
                    this.stats.errors++
                    try { store.show_notification({ text: t('Formatting applied for this session only — not saved: {reason}', { reason: String(reason || '') }), status: 'warning' }) } catch (e) { /* без уведомлений */ }
                }
                resolve({ ok, reason, answer })
            }
            const tm = setTimeout(() => fin(false, t('no answer from the server')), 20000)
            try {
                store.executeBackendMethod({}, { method: 'menu_row_format', params }, (answer) => {
                    if (answer && answer.status === 'ok' && isObj(answer.row)) { fin(true, '', answer); return }
                    const note = answer && answer.notification
                    fin(false, (answer && answer.message) || (note && note.text) || t('the server has no menu_row_format method'), answer)
                })
            } catch (e) { fin(false, String((e && e.message) || e)) }
        })
    },
    // версия записи после сохранения — в копии стола и открытых форм этой записи (их следующее сохранение не упрётся в «changed by another user»)
    versions(target, rec) {
        if (!isObj(rec) || !rec.sequence_id) return
        const rid = String(rec.id || target.record)
        const put = (r) => { if (isObj(r) && String(r.id) === rid) { r.sequence_id = rec.sequence_id; if (rec.updated_at) r.updated_at = rec.updated_at } }
        put(this.store?.WORKSPACES?.[rid]?.record)
        for (const W of this.recordWidgets(rid)) put(W.record)
    },

    // ---- рейл страниц (Page.vue): оформление плитки / подписи строки рейла по строке записи стола (страница — копия WS.PAGES, группа — строка doc.pages)
    // → { style (inline с !important: правила гамм ставят !important), has, bg, current } | null
    railFormat(workspace, row, currentPage) {
        if (!row || this.setting('fe.ux.menuPanelRowFormat', true) === false) return null
        const src = row.kind === 'group' ? tipFormat_pageGroupRow(this.store, workspace, row.key) : row.PAGE
        if (!src) return null
        const f = menuFormat_fromRow(src, MENU_FORMAT_BINDING)
        const bg = f.style['background-color'] || f.style.background || '', color = f.style.color || ''
        if (!bg && !color) return null
        const style = {}
        if (bg) { style['background-color'] = bg + ' !important'; if (!color) style.color = 'var(--text-color, #495057) !important' }
        if (color) style.color = color + ' !important'
        const current = row.kind === 'page' && !!currentPage && String(row.PAGE?.node?.value) === String(currentPage)
        return { style, has: true, bg: !!bg, current }
    },
}

export default tipFormat
